// Plugin to implement vee-validate rules and configuration. Components are imported through nuxt.config.ts
import {defineNuxtPlugin} from '#app';
import {configure, defineRule} from 'vee-validate';
import * as rules from '@vee-validate/rules';

export default defineNuxtPlugin(({vueApp}) => {
  Object.keys(rules).forEach((ruleName) => {
    // Explicitly cast the rule to the correct type
    const rule = rules[ruleName as keyof typeof rules]

    if (typeof rule === 'function') {
      defineRule(ruleName, rule);
    }
  });

  defineRule('confirmed_fields', (value: string, params: string[]) => {
    if (!value) return true;

    // value should match params[0] and the translation key should be params[1]
    if (params.length !== 2) return false;
    const [valueToMatch, fieldTranslation] = params;

    if (value === valueToMatch) return true;

    const $i18n = vueApp.config.globalProperties;

    return $i18n.$t(`validation.fields.confirmed_fields`, {fields: fieldTranslation}, '{fields} do not match');
  });

  configure({
    generateMessage: (context) => {
      // Access i18n correctly
      const $i18n = vueApp.config.globalProperties;

      const field = context.field;
      const uppercaseFirstLetter = field.charAt(0).toUpperCase() + field.slice(1);
      const params = Array.isArray(context.rule?.params) ? context.rule.params : [];
      const ruleName = context.rule?.name || '';

      // Define type-safe messages
      const messages: Record<string, string> = {
        required: $i18n.$t('validation.fields.required', {field: uppercaseFirstLetter}),
        email: $i18n.$t('validation.fields.email', {field: uppercaseFirstLetter}),
        min: $i18n.$t('validation.fields.min', {length: params[0], field: uppercaseFirstLetter}),
        min_value: $i18n.$t('validation.fields.min_value', {length: params[0], field: uppercaseFirstLetter}),
        max_value: $i18n.$t('validation.fields.max_value', {length: params[0], field: uppercaseFirstLetter}),
        max: $i18n.$t('validation.fields.max', {length: params[0], field: uppercaseFirstLetter}),
        numeric: $i18n.$t('validation.fields.numeric', {field: uppercaseFirstLetter}),
        confirmed: $i18n.$t('validation.fields.confirmed', {field: uppercaseFirstLetter}),
      };

      return messages[ruleName] || $i18n.$t('validation.default', {field: context.field});
    },
    validateOnInput: false, // triggers validation when you type
    validateOnBlur: true, // triggers validation when you blur
    validateOnChange: true, // triggers validation when the value changes
    validateOnModelUpdate: false, // triggers validation when the v-model is updated
  });
});